import { render, staticRenderFns } from "./h1-case-features.vue?vue&type=template&id=1959c98e&scoped=true&"
import script from "./h1-case-features.vue?vue&type=script&lang=js&"
export * from "./h1-case-features.vue?vue&type=script&lang=js&"
import style0 from "./h1-case-features.vue?vue&type=style&index=0&id=1959c98e&lang=scss&scoped=true&"
import style1 from "./h1-case-features.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959c98e",
  null
  
)

export default component.exports